import React, { RefObject, useRef } from 'react';
export const useFocus = <T extends HTMLElement>(): [RefObject<T>, () => void] => {
    const elementRef = useRef<T>(null);
    const setFocus = () => {
        elementRef.current && elementRef.current.focus();
    };
    return [elementRef, setFocus];
};
